import React, { useEffect, useMemo } from 'react'
import { useThemePreference } from '@theme/ThemePreferenceContext'

/** Favicon: chỉ icon Settings màu theme, không nền. */
function buildSettingsFaviconSvg(iconColor: string): string {
  return `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  <path fill="${iconColor}" d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.49.49 0 0 0-.59-.22l-2.39.96a7.07 7.07 0 0 0-1.63-.94l-.36-2.54A.48.48 0 0 0 14.4 2h-3.84c-.24 0-.44.17-.48.41l-.36 2.54c-.59.24-1.13.55-1.64.94l-2.39-.96a.49.49 0 0 0-.59.22L2.78 8.87a.48.48 0 0 0 .12.61l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94L2.9 14.52a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.3.59.22l2.39-.96c.5.39 1.05.71 1.64.94l.36 2.54c.04.24.24.41.48.41h3.84c.24 0 .44-.17.48-.41l.36-2.54c.59-.24 1.13-.55 1.63-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32a.49.49 0 0 0-.12-.61l-2.02-1.58zM12 15.6A3.6 3.6 0 1 1 12 8.4a3.6 3.6 0 0 1 0 7.2z"/>
</svg>
`.trim()
}

const ThemeFaviconUpdater: React.FC = () => {
  const { palette } = useThemePreference()

  const href = useMemo(() => {
    const svg = buildSettingsFaviconSvg(palette.primary.main)
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
  }, [palette.primary.main])

  useEffect(() => {
    if (typeof document === 'undefined') return

    const apply = (link: HTMLLinkElement) => {
      link.rel = 'icon'
      link.type = 'image/svg+xml'
      link.href = href
    }

    const existing = document.querySelector("link[rel='icon']") as HTMLLinkElement | null
    if (existing) {
      apply(existing)
      return
    }

    const link = document.createElement('link')
    apply(link)
    document.head.appendChild(link)
  }, [href])

  useEffect(() => {
    if (typeof document === 'undefined') return
    const meta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null
    if (meta) meta.content = palette.primary.main
  }, [palette.primary.main])

  return null
}

export default ThemeFaviconUpdater
